import axios from 'axios';
import { apiUrlForPath } from './api';

export const joinWaitlist = async (email) => {
  return axios.post(apiUrlForPath(`waitlist`), {
    email,
  });
};
